
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';


// REDUX
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import reducers from "trade-customer-portal/store/reducers";
import reduxThunk from 'redux-thunk';


const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

//const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
//const store = createStore(
//    reducers,
//    composeEnhancers(applyMiddleware(reduxThunk))
//);



const store = createStore(
    reducers, applyMiddleware(reduxThunk)
);


//when going to test dev to this 
//  <BrowserRouter basename={'/TradeCustomerPortalTest'} >

/*basename = { '/tradecustomerportalV2'}*/

ReactDOM.render(
    
    <BrowserRouter basename={'/TradeCustomerPortal'}>

        <Provider store={store}>
            <App />
        </Provider>
    </BrowserRouter>
    ,
    document.getElementById('root')
);

//registerServiceWorker();

